import {LayerWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';

function updateLayerIndex<Layer extends LayerWithWorkingProps>(
  layer: Layer,
  updateLogic: (currentIdx: number) => number | undefined,
): Layer {
  const res = {...layer};

  res.i = updateLogic(+res.i)?.toString() ?? '';
  if (res.pi) res.pi = updateLogic(res.pi);
  if (res.is_tm) res.is_tm = updateLogic(res.is_tm);
  if (res.has_tm) res.has_tm = updateLogic(res.has_tm);

  return res;
}

export default updateLayerIndex;
